import api from './api';

const FinancialTransactionService = {
  list: (params) => api.get('/financial-transactions', { params }),
  getOrderItemReimbursements: (orderItemId) => api.get(`/financial-transactions/order-items/${orderItemId}`),
  createManual: (data) => api.post('/financial-transactions/manual', data),
  updateManual: (id, data) => api.put(`/financial-transactions/manual/${id}`, data),
  deleteManual: (id) => api.delete(`/financial-transactions/manual/${id}`)
};

export default FinancialTransactionService;
